export default "__VITE_ASSET__F5S_VBfy__"